"use client";
import { initializeApp } from 'firebase/app'
import { Analytics, getAnalytics, logEvent } from 'firebase/analytics'

// Your Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyB7-0eANQD0Z60kGwe1AAHl5lVL2gv8g4w",
    authDomain: "cwf-coworkfit.firebaseapp.com",
    projectId: "cwf-coworkfit",
    storageBucket: "cwf-coworkfit.firebasestorage.app",
    messagingSenderId: "1052376312177",
    appId: "1:1052376312177:web:66d74a1ac2f876f6b86ed0",
    measurementId: "G-T8DBYPRT39"
}

let analytics;

const initializeFirebase = () => {
    if (typeof window !== 'undefined') {
        const app = initializeApp(firebaseConfig)
        analytics = getAnalytics(app)
    }
}

export { analytics, logEvent, initializeFirebase }